import * as antDesignVue from "ant-design-vue";

export const AAlert = antDesignVue.Alert;
export const AAvatar = antDesignVue.Avatar;
export const AButton = antDesignVue.Button;
export const ACard = antDesignVue.Card;
export const ACarousel = antDesignVue.Carousel;
export const ACheckbox = antDesignVue.Checkbox;
export const ACol = antDesignVue.Col;
export const AConfigProvider = antDesignVue.ConfigProvider;
export const ADatePicker = antDesignVue.DatePicker;
export const ADrawer = antDesignVue.Drawer;
export const ADropdown = antDesignVue.Dropdown;
export const AForm = antDesignVue.Form;
export const AFormModel = antDesignVue.FormModel;
export const AIcon = antDesignVue.Icon;
export const AInput = antDesignVue.Input;
export const ALayout = antDesignVue.Layout;
export const AMenu = antDesignVue.Menu;
export const AModal = antDesignVue.Modal;
export const ARow = antDesignVue.Row;
export const ASelect = antDesignVue.Select;
export const ASpin = antDesignVue.Spin;
export const ASwitch = antDesignVue.Switch;
export const ATable = antDesignVue.Table;
export const ATag = antDesignVue.Tag;
export const AUpload = antDesignVue.Upload;
export const notification = antDesignVue.notification;
export const APopconfirm = antDesignVue.Popconfirm;
export const APopover = antDesignVue.Popover;
export const AList = antDesignVue.List;
export const ATooltip = antDesignVue.Tooltip;
export const AEmpty = antDesignVue.Empty;
